(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('AbaFeitosMes', AbaFeitosMes);

  function AbaFeitosMes(GlosaService, $stateParams, $state) {

    var vm = this;

    vm.init = init;

    vm.registrosList = [];

    vm.init();

    function init() {
      vm.promotorSelecionado = $state.params.promotorSelecionado;
      GlosaService.getFeitosMes(vm.promotorSelecionado.originalObject.pessDk,
        $stateParams.relMensalDk, $stateParams.paiDK)
      .then(function (data) {
          vm.registrosList = data;
      });
    }
  }

})();
